import { Tabs } from '@mui/material';
import { styled } from '@mui/system';

const TabsWrapper = styled(Tabs)(() =>({
  fontWeight: 400,
  '& .MuiTabs-scroller .MuiTabs-flexContainer .MuiButtonBase-root': {
    borderTop: '0px solid transparent',
    borderRight: '1px solid #D6D6D6',
    borderBottom: '1px solid #D6D6D6',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    color: '#878787',
    padding: '20px',
  },
  '& .MuiTabs-scroller .MuiTabs-flexContainer .MuiButtonBase-root:first-child': {
    borderLeft: '0px solid transparent',
  },
  '& .MuiTabScrollButton-horizontal.Mui-disabled': {
    display: 'none !important',
  },
}));


export {
  TabsWrapper,
};

